export default __webpack_public_path__ + "6618064585d2cd0bbd307d0d14516f87.png";